import { Modal, Table } from "react-bootstrap";
import useCallApi from "../../hooks/useCallApi";
import Loading from "../../templates/UI/Loading/Loading";
import moment from "moment";
import Affiliate from "../../templates/Affiliate/Affiliate";

const RateHistoryModal = ({ isOpen, onClose, rateName, campaignId, specialRates, affiliateId }) => {
    const { data, dataLoaded } = useCallApi(`campaign/${campaignId}/rateHistory/${rateName}${(affiliateId && affiliateId) > 0 ? `?affiliateId=${affiliateId}` : ''}`, 'GET', {}, [rateName, campaignId, affiliateId])

    return (
        <Modal size="xl" show={isOpen} onHide={onClose} centered>
            <Modal.Header>
                <Modal.Title>Rate History for <strong>{rateName}</strong></Modal.Title>

            </Modal.Header>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Change</th>
                        <th>Date</th>
                        <th>Affiliate</th>
                        <th className='text-right'>Aff. Rate</th>
                        <th className='text-right'>Net Rate</th>
                        <th>Rate Type</th>
                        <th className='text-right'>Dis. Aff</th>
                        <th className='text-right'>Dis. Net</th>
                        <th>Dis. Type</th>
                        <th style={{ textDecoration: "line-through" }}>Sale</th>
                        <th>Changed By</th>
                    </tr>
                </thead>
                <tbody>
                    {dataLoaded ? (
                        data.rateHistory?.length > 0 ? (
                            data.rateHistory.map((entry, index) => {
                                if (specialRates) {
                                    if (entry.affiliate_id > 0){
                                        return <tr key={index}>
                                            <td>{entry.action_type}</td>
                                            <td>{moment(entry.db_date).utc().format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td><Affiliate aid={entry.affiliate_id} name={entry.affiliate_name} priority={entry.affiliate_priority} /></td>
                                            <td className='text-right'>{entry.offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.affiliate_rate)}` : `${entry.affiliate_rate}%`}</td>
                                            <td className='text-right'>{entry.offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.network_rate)}` : `${entry.network_rate}%`}</td>
                                            <td>{entry.offer_type}</td>
                                            <td className='text-right'>{entry.display_rate && (entry.display_offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.display_rate)}` : `${entry.display_rate}%`)}</td>
                                            <td className='text-right'>{entry.display_net_rate && (entry.display_offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.display_net_rate)}` : `${entry.display_net_rate}%`)}</td>
                                            <td>{entry.display_offer_type}</td>
                                            <td>{entry.hide_sale_amount == "Y" ? 'Yes' : 'No'}</td>
                                            <td>{entry.full_name}</td>
                                        </tr>
                                    } else {
                                        return entry.affiliate_id
                                    }
                                } else {
                                    if (entry.affiliate_id === 0 || !entry.affiliate_id || entry.affiliate_id === null) {
                                        return <tr key={index}>
                                                <td>{entry.action_type}</td>
                                                <td>{moment(entry.db_date).utc().format('YYYY-MM-DD HH:mm:ss')}</td>
                                                <td></td>
                                                <td className='text-right'>{entry.offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.affiliate_rate)}` : `${entry.affiliate_rate}%`}</td>
                                                <td className='text-right'>{entry.offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.network_rate)}` : `${entry.network_rate}%`}</td>
                                                <td>{entry.offer_type}</td>
                                                <td className='text-right'>{entry.display_rate && (entry.display_offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.display_rate)}` : `${entry.display_rate}%`)}</td>
                                                <td className='text-right'>{entry.display_net_rate && (entry.display_offer_type === 'Fixed' ? `$${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entry.display_net_rate)}` : `${entry.display_net_rate}%`)}</td>
                                                <td>{entry.display_offer_type}</td>
                                                <td>{entry.hide_sale_amount == "Y" ? 'Yes' : 'No'}</td>
                                                <td>{entry.full_name}</td>
                                            </tr>                                        
                                    }  else {
                                        return null
                                    }
                                }                                
                            })
                        ) : (
                            <tr>
                                <td colSpan="10" className="text-center">No rate history available.</td>
                            </tr>
                        )
                    ) : (
                        <Loading />
                    )}
                </tbody>
            </Table>
        </Modal>
    );
}
export default RateHistoryModal;